"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Typography = _interopRequireDefault(require("@eig-builder/core-ui/Typography"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  padding-left: ", ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: ", ";\n  line-height: ", "; /* fallback */\n  max-height: ", "; /* fallback */\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var MAX_LINES = 3;
var LINE_HEIGHT = 24;

var TitleBase = _styledComponents["default"].div(_templateObject(), function (props) {
  return "".concat(props.theme.spacing(3), "px");
}, MAX_LINES, "".concat(LINE_HEIGHT, "px"), "".concat(MAX_LINES * LINE_HEIGHT, "px"));

var Title = function Title(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle;
  return _react["default"].createElement(TitleBase, null, _react["default"].createElement(_Typography["default"], {
    variant: "h3",
    subtitle: subtitle
  }, title), subtitle && _react["default"].createElement(_Typography["default"], {
    variant: "subtitle2"
  }, subtitle));
};

Title.propTypes = {
  title: _propTypes["default"].node,
  subtitle: _propTypes["default"].node
};
var _default = Title;
exports["default"] = _default;